import React from 'react';

import CLocalizedText from '../../../components/CLocalizedText';
import CLocalizedTextString from '../../../components/CLocalizedTextString';
import CPageModule from '../../../components/CPageModule';
import Page from '../../../components/layout/Page';

export default function PTermsOfUseIndex() {
  return (
    <Page title={CLocalizedTextString('global.termsOfUse.footer.button')}>
      <CPageModule>
        <div>
          <CLocalizedText dictKey={'global.termsOfUse.text'}></CLocalizedText>
        </div>
      </CPageModule>
    </Page>
  );
}
